import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/leadStatusSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const BreakdownMetricFilter = ({ slice, name }) => {
  const dispatch = useDispatch();

  const allOptions = useSelector((state) => state.leadStatus.filters[slice]);
  const selectedOptions = useSelector((state) => state.leadStatus.selectedFilters[slice]);

  const onSelectChange = (data) => dispatch(actionCreators.updateFilter({ key: slice, data }));

  return (
    <div className="select-box-no-width">
      <p>{name}</p>
      <MultiSelectDropdown
        placeholder="Select"
        options={allOptions}
        selectedFilters={selectedOptions}
        numberDisplayed={0}
        onSelectChange={onSelectChange}
      />
    </div>
  );
};
